import { render, staticRenderFns } from "./TradersFeesBlock.vue?vue&type=template&id=dbdaa77c&scoped=true&"
import script from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
export * from "./TradersFeesBlock.vue?vue&type=script&lang=js&"
import style0 from "./TradersFeesBlock.vue?vue&type=style&index=0&id=dbdaa77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdaa77c",
  null
  
)

export default component.exports